import React, { lazy } from "react";

const LazyGaiaAi = lazy(() => import("./GaiaAi"));

const GaiaAi = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode }
) => <LazyGaiaAi {...props} />;

export default GaiaAi;
